import { VisualizationAgentResponse } from "@pufflig/prompt-studio-types";
import { finishThread, getThreadParams, getThreadValue, hasThread, setThreadValue } from "./threads/threads";

/**
 * Handles the response from the visualization agent.
 *
 * @param event
 * @returns
 */
export const handleVisualizationResponse = async (parsedData: VisualizationAgentResponse) => {
  const threadId = parsedData.threadId;

  if (parsedData.type !== "visualization_agent_response" || !hasThread(threadId)) return;

  const params = getThreadParams(threadId);
  const visualization = getThreadValue(threadId, "visualization");
  const resultName = JSON.parse(params.schema)?.tableName || "visualization";

  try {
    if (parsedData.error) {
      finishThread(threadId, `visualize(${resultName}): ${parsedData.error}`, true);
    }

    if (parsedData.visualization) {
      setThreadValue(threadId, "visualization", parsedData.visualization);
    }

    if (parsedData.isDone) {
      if (!visualization) {
        finishThread(threadId, `visualize(${resultName}): No visualization found`, true);
        return;
      }

      finishThread(threadId, [visualization]);
    }
  } catch (err) {
    finishThread(threadId, `visualize(${resultName}): Error parsing WebSocket message: ${err}`, true);
  }
};
